import { useState, isValidElement } from 'react';
import { theme } from 'antd';
import styles from '../style.module.less';
import type { SearchData, TitleRenderData } from './types';
import type { DataNode } from 'antd/es/tree';
import type { ReactNode } from 'react';

export function useTitleRender(search: SearchData): TitleRenderData {
  const { token } = theme.useToken();
  const [searchValue, setSearchValue] = useState('');

  const onSearchChange = (value: string): void => {
    search.onSearch(value);
    setSearchValue(value);
  };

  const titleRender = (treeNode: DataNode): ReactNode => {
    // 使用端可以直接指定 react element 绘制复杂的 tree item，
    // 这时直接返回，注意需要自行处理高亮逻辑
    if (isValidElement(treeNode.title)) {
      return treeNode.title;
    }

    const title = treeNode.title as string;
    const isMatched: boolean = searchValue !== '' && title.includes?.(searchValue);

    if (isMatched) {
      return <div className={styles.treeHighLight} style={{ color: token.colorPrimary }}>{title}</div>;
    }
    return title;
  };

  return {
    onSearchChange,
    titleRender,
    searchValue
  };
}
